import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from 'styled-components';
import { darkTheme, lightTheme } from './components/stateProvider/Themes';
import { useGlobalState } from './components/stateProvider/StateProvider';
import LogIn from './components/pages/LogIn';
import Modal from './components/Modal';
import { GlobalStyle } from './components/stateProvider/GlobalStyles';
import { useEffect, useLayoutEffect, useState } from 'react';
import { lastKeyPress, getLocal, setLocal, getDeviceFingerprint } from './components/utility/functions';
import ToS from './components/pages/ToS';
import KioskSignup from './components/pages/KioskSignup';
import UsersContext from './components/stateProvider/UsersContext';
import DashRouter from './components/navigation/DashRouter';
import { Route, Routes } from 'react-router-dom';
import HelpToolTip from './components/HelpToolTip';
import ModalFactory from './components/Modal';
import { NewUpdateLanding } from './components/pages/Updates';
require('typeface-montserrat')

function App() {
    const {
        state: {
            active_user,
            dark_theme,
        },
        updateUnauthorized,
    } = useGlobalState();

    const [fingerprint, setFingerprint] = useState(null);

    useLayoutEffect(() => {

        // const info = getDeviceFingerprint();
        // const temp = [info.cpuCores, info.screenResolution, info.platform, info.userAgent].join('|');
        // const encode = btoa(temp);
        // const decode = atob(encode);

        console.log(
            '%cHosty Solushy!!',
            `font-family: 'Roboto', sans-serif;
             padding: 0.3em 0.5em;
             background: linear-gradient(45deg, #daf7ff, #a1e3ff, #65e2ff, #99f4ff, #c0f9ff);
             font-weight: bold;
             font-size: 60px;
             color: #004280;
             border-radius: 15px;
             text-shadow: 2px 2px 0 #5377c9, 4px 4px 0 #3890fe, 6px 6px 0 #01C5FC,
                          8px 8px 0 #65e2ff, 10px 10px 0 #99f4ff, 12px 12px 0 #c0f9ff,
                          14px 14px 0 #e0fbff, 16px 16px 0 #ffffff;
             box-shadow: 0 0 15px rgba(0, 0, 0, 0.5), 0 0 30px rgba(0, 200, 255, 0.7), 0 0 45px rgba(0, 150, 255, 0.9);
             transform: rotate(-2deg) skew(1deg, 1deg);
             border: 4px solid #004280;
             outline: 8px solid rgba(0, 200, 255, 0.5);`
        );

        if (process.env.REACT_APP_ENV !== 'prod') {
            console.log('ENV:', process.env.REACT_APP_ENV);
            // setTimeout(() => console.clear(), 500)
        }

        updateUnauthorized();

        const keyDownHandler = e => lastKeyPress.key = e.key;
        document.addEventListener('keydown', keyDownHandler);
        return () => document.removeEventListener('keydown', keyDownHandler);
    }, []);

    useEffect(() => {
        if (active_user.isLoggedIn && !active_user.tosAccepted) {
            ModalFactory.show({
                id: 'ToS',
                title: 'Hosted Solutions Terms of Service',
                body: <ToS />,
            })
        }
    }, [active_user.isLoggedIn, active_user.tosAccepted]);

    useEffect(() => {
        if (active_user.isLoggedIn && active_user.tosAccepted && active_user.userId) {
            const landingKey = `${active_user.userId}_landing`;
            if (!getLocal(landingKey)) {
                setLocal(landingKey, true);
                ModalFactory.show({
                    title: `Hi ${active_user.firstName}!`,
                    body: <NewUpdateLanding />,
                })
            }
        }
    }, [active_user]);

    return (
        <ErrorBoundary>
            <ThemeProvider theme={dark_theme ? darkTheme : lightTheme}>
                <UsersContext>
                    <GlobalStyle />
                    <Routes>
                        <Route index path={'/AccountSetUp/:token'} element={<KioskSignup />} />
                        <Route path='*' element={
                            <HelpToolTip>
                                <Modal />
                                <LogIn />
                                {(active_user.isLoggedIn && active_user.tosAccepted) ? <DashRouter /> : null}
                            </HelpToolTip>
                        } />
                    </Routes>
                </UsersContext>
            </ThemeProvider>
        </ErrorBoundary>
    );
}

export default App;
